<template>
    <div>
      <div class="clearfix">
        <Form @submit.native.prevent :model="formData" label-position="left" class="mytable-titleBox fl">
          <FormItem label="用户昵称:" class="fl mytable-title" :label-width="72">
            <Input v-model="formData.username"></Input>
          </FormItem>
          <FormItem label="手机号:" class="fl mytable-title" :label-width="72">
            <Input v-model="formData.phone"></Input>
          </FormItem>
        </Form>
        <div class="fl checkReset">
          <Button type="primary" class="fl" @click="handleQuery">查询</Button>
          <Button class="fl" @click="handleReset">重置</Button>
        </div>
      </div>
      <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
      <Page class="mt24" :total="total" :current="page_num" show-elevator show-sizer show-total @on-page-size-change="handleSizeChange" @on-change="handlePageChange"/>

    </div>
</template>

<script>
import mixins from '@/mixins/page'
export default {
  name: 'user_manage',
  mixins: [mixins],
  data () {
    return {
      formData: {},
      formData1: {},
      tableData: [],
      columns: [
        {
          title: '用户id',
          key: 'id'
        },
        {
          title: '用户昵称',
          key: 'username'
        },
        {
          title: '用户头像',
          key: 'poster',
          render: (h, params) => {
            return h('img', {
              class: {
                table_pic: true
              },
              domProps: {
                src: params.row.poster
              }
            })
          }
        },
        {
          title: '手机号',
          key: 'phone'
        },
        {
          title: '来源',
          key: 'applet_type',
          width: '170px',
          render: (h, params) => {
            if (params.row.applet_type === 1) {
              return h('span', {

              }, '内部分享')
            } else if (params.row.applet_type === 2) {
              return h('span', {

              }, '内部说')
            } else if (params.row.applet_type === 3) {
              return h('span', {

              }, '足球财富资讯')
            } else if (params.row.applet_type === 4) {
              return h('span', {
              }, '内部料')
            } else {
              return h('span', {
              }, '未知')
            }
          }

        },
        {
          title: '创建时间',
          key: 'create_time'
        }
      ]
    }
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    handleReset () {
      this.formData = Object.assign({}, this.formData1)
      this.handleQuery()
    },
    handleQuery () {
      this.page_num = 1
      this.getTableData()
    },
    getTableData () {
      this.tableLoading = true
      this.$api.queryUser({ ...this.formData, page_num: this.page_num, page_size: this.page_size }).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.list
          this.total = res.data.total_row
        } else {
          this.$Message.error(res.msg)
        }
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .table_pic{
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
</style>
